import { SVC_QA_COMMENTS } from './catalogFixtures';
import type { QaCat, QaStatus, SvcCatalog, SvcCodeRow, SvcQa } from './catalogTypes';

export const QA_CATS: ReadonlyArray<readonly [QaCat, string]> = [
  ['booking', 'Booking'], ['docs', 'Chứng từ'], ['cargo', 'Hàng hoá'], ['schedule', 'Lịch & hạn'], ['charge', 'Phí'], ['customs', 'Hải quan'], ['incident', 'Sự cố'], ['other', 'Khác'],
];
export const QA_ST: Readonly<Record<QaStatus, { label: string; tone: 'green' | 'gray' | 'amber' }>> = {
  pub: { label: 'Đã xuất bản', tone: 'green' }, draft: { label: 'Nháp', tone: 'gray' }, ask: { label: 'Câu hỏi chờ trả lời', tone: 'amber' },
};
export const GROUPS = ['FRT', 'ADD', 'OTH'] as const;

export const catLabel = (k: QaCat) => QA_CATS.find((c) => c[0] === k)?.[1] ?? 'Khác';
export const norm = (x: string) => x.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').toLowerCase().trim();

export const filterCatalog = (rows: readonly SvcCatalog[], q: string) => {
  const n = norm(q);
  return rows.filter((s) => !n || norm(`${s.code} ${s.name} ${s.en} ${s.desc}`).includes(n));
};
export const filterCodes = (rows: readonly SvcCodeRow[], q: string, grp: string) => {
  const n = norm(q);
  return rows.filter((c) => (grp === 'all' || c.grp === grp) && (!n || norm(`${c.code} ${c.vi} ${c.en}`).includes(n))).slice().sort((a, b) => a.ord - b.ord);
};
export const filterQa = (rows: readonly SvcQa[], q: string) => {
  const n = norm(q);
  return rows.filter((x) => !n || norm(`${x.title} ${x.sum} ${x.tags.join(' ')}`).includes(n));
};

/** Số điểm chưa rõ còn mở của một câu hỏi. */
export const openUnclear = (id: string) => (SVC_QA_COMMENTS[id] ?? []).filter((c) => c[3] && !c[4]).length;
export const firstUnclear = (id: string) => (SVC_QA_COMMENTS[id] ?? []).find((c) => c[3] && !c[4])?.[1] ?? '';
export const commentCount = (id: string) => (SVC_QA_COMMENTS[id] ?? []).length;
